import React, { useState, useEffect,useContext } from 'react';
import Context from "../context/context";
import Widget from './Widget';
import FilterTotals from './FilterTotals';


const Filters = props => {

  const {clearAllFilters} = props;
  const {filterNav} = useContext(Context);
  const [open, setOpen] = useState(false)
  return (
    <>
    <div class={`filter-trigger ${open ? 'active' : ''}`} onClick={() => setOpen(!open)}>Filter</div>
    <div className={`filter-wrapper ${open ? 'active' : ''}`}>
      <div className="filter-form-wrapper">
        <div className="filter-title">Filter By</div>
        <div class="filter-form">
          {filterNav.map((widget, i) => {
              if (widget.position != "top" && widget.type != "hidden"){
                return <Widget
                          key={i}
                          widget={widget}
                          clearAllFilters={clearAllFilters}
                      />
              }

            })}

        </div>

        </div>
        <FilterTotals />
      </div>
    </>
  )
}

export default Filters;
